import { transformToPixels } from "../nsLayout/common/helpers";

import { HEADER_GAP } from "../nsLayout/constants";

export const useConstructorPage = () => {
    const transformContentPadding = () => {
        const $content = document.querySelector(".js-ns-content-padding");

        if (!$content) {
            return;
        }

        try {
            const $header = document.querySelector(".js-ns-header");
            const $mobileHeader = document.querySelector(
                ".js-ns-mobile-header"
            );
            const windowWidth = window.innerWidth;

            if (!$header || !$mobileHeader) {
                return;
            }

            const headerHeight = $header.clientHeight;
            const mobileHeaderHeight = $mobileHeader.clientHeight;

            $content.style.paddingTop =
                windowWidth >= 1024
                    ? transformToPixels(headerHeight + HEADER_GAP)
                    : transformToPixels(mobileHeaderHeight);
        } catch (e) {
            console.log(e);
        }
    };

    const initContentPadding = () => {
        window.addEventListener("DOMContentLoaded", transformContentPadding);
        window.addEventListener("resize", transformContentPadding);
    };

    return {
        transformContentPadding,
        initContentPadding,
    };
};
